var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.87868 3.87868C1.44129 3.31607 2.20435 3 3 3H10C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V20C20 20.7957 19.6839 21.5587 19.1213 22.1213C18.5587 22.6839 17.7957 23 17 23H3C2.20435 23 1.44129 22.6839 0.87868 22.1213C0.31607 21.5587 0 20.7957 0 20V6C0 5.20435 0.31607 4.44129 0.87868 3.87868Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2.87891C18.7026 2.87891 18.4174 2.99705 18.2071 3.20733L8.90299 12.5115L8.37439 14.6259L10.4888 14.0973L19.7929 4.79312C20.0032 4.58283 20.1213 4.29762 20.1213 4.00023C20.1213 3.70283 20.0032 3.41762 19.7929 3.20733C19.5826 2.99705 19.2974 2.87891 19 2.87891ZM16.7929 1.79312C17.3783 1.20776 18.1722 0.878906 19 0.878906C19.8278 0.878906 20.6218 1.20776 21.2071 1.79312C21.7925 2.37848 22.1213 3.1724 22.1213 4.00023C22.1213 4.82805 21.7925 5.62197 21.2071 6.20733L11.7071 15.7073C11.579 15.8355 11.4184 15.9264 11.2426 15.9704L7.24256 16.9704C6.90178 17.0556 6.54129 16.9557 6.29291 16.7073C6.04453 16.459 5.94468 16.0985 6.02988 15.7577L7.02988 11.7577C7.07384 11.5819 7.16476 11.4213 7.29291 11.2931L16.7929 1.79312Z",
    fill: "#A8A8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f9bfe91e.svg";
export { ForwardRef as ReactComponent };